import {memo} from 'react';

import {getLocalizationService} from '~/shared/services/localisationService';
import {useSideMenuHandlers} from '~/common/hooks/UserTransactions';
import {Title} from '~/shared/components/UserTransactions/shared';
import CustomTable from '~/shared/components/UserTransactions/components/CustomTable/CustomTable';

type DesktopProps = {
  tableHeaderCustomColor?: string;
  columns: unknown[];
  rows: unknown[];
};

const DesktopActiveTable = ({columns, rows, tableHeaderCustomColor}: DesktopProps) => {
  const {t} = getLocalizationService();
  const menuActions = useSideMenuHandlers();

  return (
    <>
      <Title>{t('active_orders')}</Title>
      <CustomTable
        hideToggleArrow
        menuEvents={menuActions}
        columns={columns}
        rows={rows}
        getCssClasses={undefined}
        mobile={false}
        withRoundedCorners
        boldAllPrices
        tableHeaderCustomColor={tableHeaderCustomColor}
      />
    </>
  );
};

export default memo(DesktopActiveTable);
